// extracted by mini-css-extract-plugin
export default {"SimpleDropdown_container":"styles_SimpleDropdown_container__YjwU8","SimpleDropdown_options":"styles_SimpleDropdown_options__Sb6oY","footer":"styles_footer__blCim"};